"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModelBase_1 = require("../ModelBase");
var MappedType_1 = require("./MappedType");
var DataItem_1 = require("../common/base/DataItem");
var Field_1 = require("../../constants/Field");
var lodash_1 = require("lodash");
var DataType_1 = require("../common/base/DataType");
var MappingProperties = /** @class */ (function () {
    function MappingProperties(deviceType, sceEngModels) {
        this.deviceType = new ModelBase_1.ModelBase(deviceType.model, deviceType.typeId, deviceType.version);
        this.sceEngModels = sceEngModels;
    }
    MappingProperties.fromJson = function (json) {
        var deviceType = ModelBase_1.ModelBase.fromJson(json[Field_1.FIELD.DEVICETYPE]);
        var sceEnggModelsJson = json[Field_1.FIELD.SCEENGGMODELS];
        var sceEnggModels = lodash_1.map(Object.keys(sceEnggModelsJson), function (id) {
            return MappedType_1.MappedType.fromJson(id, sceEnggModelsJson[id]);
        });
        return new MappingProperties(deviceType, sceEnggModels);
    };
    /**
     *
     * @param id id field
     * @param category category is the value field for state
     */
    MappingProperties.prototype.addType = function (id, saveOption, assetMonitorModel) {
        var state = new DataItem_1.DataItem(Field_1.FIELD.STATE, DataType_1.DataType.string);
        state.value = saveOption;
        state.dataType = undefined;
        var model = new DataItem_1.DataItem(Field_1.FIELD.MODEL, DataType_1.DataType.string);
        model.value = assetMonitorModel;
        model.dataType = undefined;
        var mappedType = new MappedType_1.MappedType(id, state, model);
        if (!this.sceEngModels) {
            this.sceEngModels = [];
        }
        this.sceEngModels.push(mappedType);
    };
    MappingProperties.prototype.removeType = function (id) {
        var index = lodash_1.findIndex(this.sceEngModels, { id: id });
        if (index !== -1) {
            this.sceEngModels.splice(index, 1);
        }
    };
    MappingProperties.prototype.getMappedType = function (id) {
        return lodash_1.find(this.sceEngModels, { id: id });
    };
    MappingProperties.prototype.getSaveOption = function (id) {
        var sceEngModel = lodash_1.find(this.sceEngModels, { id: id });
        if (sceEngModel) {
            return sceEngModel.state.value;
        }
        return undefined;
    };
    MappingProperties.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.DEVICETYPE] = this.deviceType.toJson();
        var sceEnggModels = Object.create(null);
        lodash_1.map(this.sceEngModels, function (sceEnggModel) {
            sceEnggModels = Object.assign(sceEnggModels, sceEnggModel.toJson());
        });
        json[Field_1.FIELD.SCEENGGMODELS] = sceEnggModels;
        return json;
    };
    return MappingProperties;
}());
exports.MappingProperties = MappingProperties;
//# sourceMappingURL=MappingProperties.js.map